import React, {
  createContext,
  FC,
  useContext,
  useState,
  ReactNode,
} from 'react';

import { Modal } from '@design-system/modal';
import { Typography } from '@design-system/typography';

import {
  ModalContextValue,
  ModalProviderProps,
  ModalState,
} from './models';

const ModalContext = createContext<ModalContextValue | null>(null);

export const ModalProvider: FC<ModalProviderProps> = ({ children }) => {
  const [modal, setModal] = useState<ModalState>({
    isOpen: false,
    content: null,
    title: null,
  });

const openModal = (content: ReactNode, title?: string) => {
  setModal({
    isOpen: true,
    content,
    title: title ?? null,
  });
};

const closeModal = () => {
  setModal({
    isOpen: false,
    content: null,
    title: null,
  });
};

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
        {modal.isOpen && (
        <Modal
            isShowing
            closeModal={closeModal}
            className="profession-confirmation-dialog"
            showCloseButton
            topElements={
            modal.title ? (
                <Typography
                align="center"
                tag="h3"
                weight="bold"
                variant="headline"
                size="m"
                content={modal.title}
                />
            ) : null
            }
        >
            {modal.content}
        </Modal>
        )}
    </ModalContext.Provider>
  );
};

export const useModal = (): ModalContextValue => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }

  return context;
};